import { useToastStore } from "../../stores/toast";

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  const remove = useToastStore((s) => s.remove);
  const hold = useToastStore((s) => s.hold);
  const release = useToastStore((s) => s.release);

  // Le conteneur est monté en permanence, même vide : une région live insérée
  // en même temps que son contenu n'est pas restituée de façon fiable. Sans
  // cela, l'apparition d'un bouton « Annuler » — seul garde-fou d'un
  // déplacement instantané — n'était jamais annoncée.
  return (
    <div className="toast-container" role="status" aria-live="polite" aria-atomic="false">
      {toasts.map((t) => {
        const action = t.action;
        return (
          <div
            key={t.id}
            className={`toast toast--${t.variant}`}
            // Tant que la notification est survolée ou porte le focus clavier,
            // elle ne s'efface pas : atteindre « Annuler » au clavier demande
            // de traverser la page, et le minuteur gagnait la course.
            onMouseEnter={() => hold(t.id)}
            onMouseLeave={() => release(t.id)}
            onFocus={() => hold(t.id)}
            onBlur={() => release(t.id)}
          >
            <div className="toast__title">{t.title}</div>
            {t.body ? <div className="toast__body">{t.body}</div> : null}
            {action ? (
              <button
                type="button"
                className="toast__action"
                onClick={() => {
                  // La notification a fait son office dès que l'action est lancée :
                  // la laisser affichée inviterait à cliquer deux fois.
                  action.onClick();
                  remove(t.id);
                }}
              >
                {action.label}
              </button>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
